const e = {
	en: {
		calendar: "gregory",
		numberingSystem: "latn",
		region: "US"
	},
	fa: {
		calendar: "persian",
		numberingSystem: "latn",
		region: "IR"
	}
};
function n(n) {
	const t = new Intl.Locale(n), a = e[t.language];
	return a ? new Intl.Locale(t, {
		calendar: t.calendar ?? a.calendar,
		numberingSystem: t.numberingSystem ?? a.numberingSystem,
		region: t.region ?? a.region
	}) : t;
}
var t = class {
	#e;
	#n = /* @__PURE__ */ new Set();
	constructor(e) {
		const t = e ?? ("undefined" == typeof document ? "en" : document.documentElement?.lang || "en");
		this.#e = n(t);
	}
	get locale() {
		return this.#e;
	}
	#t(e) {
		const t = n(e);
		return this.#e.toString() !== t.toString() && (this.#e = t, !0);
	}
	setLocale(e) {
		this.#t(e) && this.#a();
	}
	subscribe(e) {
		return this.#n.add(e), () => this.#n.delete(e);
	}
	#a() {
		[...this.#n].forEach((e) => {
			e();
		});
	}
};
const a = new t();
function r(e, n) {
	return "fa" === e.locale.language ? n ? `لطفاً ${n} خود را وارد نمایید` : "لطفاً این قسمت را پر کنید" : n ? `Please enter your ${n}` : "Please complete this field";
}
var l = class {
	constructor(e, n = {}) {
		this.dictionary = {}, this.dictionary = e, this.fallbackLanguage = n.fallbackLanguage ?? "en";
	}
	setLanguage(e, n) {
		this.dictionary[e] = n;
	}
	get(e, n) {
		const t = [
			e.locale.baseName,
			e.locale.language,
			this.fallbackLanguage,
			"en"
		], a = /* @__PURE__ */ new Set();
		for (const e of t) {
			if (a.has(e)) continue;
			a.add(e);
			const t = this.dictionary[e];
			if (t && Object.getOwnPropertyDescriptor(t, n)) return t[n];
		}
		return console.error(`Missing i18n message "${String(n)}" for locale "${e.locale.toString()}"`), "";
	}
};
export { l as JBDictionary, t as JBI18N, r as getRequiredMessage, a as i18n, n as resolveLocale };

//# sourceMappingURL=index.js.map